
import { gql } from '@apollo/client';
 
export const VALIDATE_VOUCHER = gql`
  mutation ValidateVoucher($voucherCode: String!, $journeyType:String!) {
    validateVoucher(input: { VoucherCode: $voucherCode }, journeyType:$journeyType) {
      RequestStatus
      Description
      VoucherStatus
      ProductType
      OfferId
      ExpiryDate
      Campaigns
      ServiceCodes
    }
  }
`;